<template>
  <div v-if="isReady">
    <Panel :padding="[22, 24]">
      <div class="question-desc">
        <div>{{ currItem.question_description_obj[computedLang] }}</div>
        <slot></slot>
      </div>
      <div class="panel-content">
        <div class="panel-article">
          <p>{{ currItem.screen_text[0].content }}</p>
          <div class="key-words">
            <div class="key-words-item" v-for="(item, index) in currItem.screen_text[1].content.split(' ')" :key="index">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="answer_result">
          <div>{{ $t('mark_answer') }}:</div>
          <strong>{{ currItem.useAnswer || $t('hsk_homework_no_answer') }}</strong>
          <div class="limit">{{ wordLength || 0 }}/100</div>
        </div>
        <div class="reference_answer">
          <div>{{ $t('hsk_reference_answer') }}</div>
          <p v-for="(item, index) in analysisText" :key="index">
            {{ item }}
          </p>
        </div>
        <AiSuggestScore :score="currItem.aiScores" />
      </div>
    </Panel>
  </div>
</template>

<script>
import { getAllWordsLength } from '@/utils/utils'
export default {
  name: 'CommonWritePaResult',
  props: {
    currItem: {
      type: Object,
      default: () => {},
    },
    baseUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    isReady() {
      return JSON.stringify(this.currItem) !== '{}'
    },
    computedLang() {
      return localStorage.getItem('language') || 'en'
    },
    analysisText() {
      return this.currItem.evaluate.standard_answer[0].split('\n')
    },
    wordLength() {
      return getAllWordsLength(this.currItem.useAnswer)
    },
  },
}
</script>

<style lang="scss" scoped>
.question-desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.panel-content {
  margin-left: 32px;
  margin-top: 12px;
  .panel-article {
    img {
      width: 280px;
      height: 156px;
      border-radius: 4px;
      margin-top: 10px;
      object-fit: contain;
    }
    p {
      color: #696974;
      font-weight: 400;
      font-size: 14px;
    }
    .key-words {
      display: flex;
      margin-top: 12px;
      &-item {
        font-weight: 600;
        font-size: 16px;
        margin-right: 16px;
        color: #2c2f46;
      }
    }
  }
  .answer_result {
    div {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    strong {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      align-self: flex-start;
    }
    .limit {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      margin-top: 10px;
      text-align: right;
    }
  }
  .reference_answer {
    margin-top: 24px;
    div {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    p {
      font-size: 14px;
      color: #545961;
      line-height: 25px;
      text-indent: 2em;
    }
  }
}
</style>
